var exports = {
  "YL": "Tooltip.module__tooltip___NmY2NU",
  "xQ": "Tooltip.module__tooltipPointer___NmY2NU",
  "rv": "Tooltip.module__tooltipContent___NmY2NU",
  "iU": "Tooltip.module__tooltipContentLarge___NmY2NU" + " " + "Tooltip.module__tooltipContent___NmY2NU",
  "dn": "Tooltip.module__tooltipTop___NmY2NU",
  "L_": "Tooltip.module__tooltipBottom___NmY2NU",
  "Lf": "Tooltip.module__tooltipLeft___NmY2NU",
  "Uu": "Tooltip.module__tooltipRight___NmY2NU",
  "A4": "Tooltip.module__tooltipPrimary___NmY2NU",
  "yH": "Tooltip.module__tooltipPointerBg___NmY2NU",
  "Rp": "Tooltip.module__tooltipRed___NmY2NU",
  "vX": "Tooltip.module__tooltips___NmY2NU",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___NmY2NU",
  "IM": "Tooltip.module__triggerWrapper___NmY2NU",
};

module.exports = exports;
